import React, { Component } from 'react';
import { withAsyncActions } from 'react-async-client';
import { path } from 'ramda';
import moment from 'moment';

import DatePicker from './DatePicker';
import { getSalePlansPromoterStatus, formAutoOptions } from 'actions/asyncActions';
import withRole from '../withRole';

const SALE_DATE_ERROR = 'На этот день нет плана в табеле';

@withRole
@withAsyncActions({
    getSalePlansPromoterStatus: getSalePlansPromoterStatus
        .withSuccessHandler(({ requireWorkShift, getSalePlansPromoterStatus: { data }, form }) => {
            const { setFieldValue, setFieldError, values } = form;
            const shop = path(['shop', 'id'], data);
            const department = path(['productDepartment', 'id'], data);
            const requireShift = requireWorkShift !== false;

            if (shop && department) {
                setFieldValue('department', department);
                setFieldValue('_embedded', {
                    ...(values._embedded || {}),
                    department: data.productDepartment,
                    shop: data.shop,
                });
                setFieldValue('shop', shop);
                setFieldError('date', null);
            } else if (requireShift) {
                setFieldError('date', SALE_DATE_ERROR);
            } else {
                setFieldError('date', null);
            }
        })
        .withErrorHandler(({ requireWorkShift, form: { setFieldError }}) => {
            if (requireWorkShift !== false) {
                setFieldError('date', SALE_DATE_ERROR);
            } else {
                setFieldError('date', null);
            }
        })
}, formAutoOptions)
export default class SaleDatePicker extends Component {
    componentDidMount() {
        const date = path(['value'], this.props.field);

        if (date) {
            this.onChange(date, path(['values', 'promoter'], this.props.form));
        }
    }

    onChange = (date, promoter) => {
        const { getSalePlansPromoterStatus, form: { setFieldValue, values }} = this.props;

        setFieldValue('shop', null);
        setFieldValue('department', null);

        if (date) {
            getSalePlansPromoterStatus.dispatch({ q: { date: date ? moment.utc(date).startOf('day') : null, promoter: promoter || values.promoter }});
        }
    }

    componentWillReceiveProps(next) {
        const { form: { errors, setFieldError, values: { shop, date, promoter }}} = next;
        const { form } = this.props;

        if (next.requireWorkShift !== false && form.errors.date && !errors.date && date && !shop) {
            setFieldError('date', SALE_DATE_ERROR);
        }

        if (form.values.promoter !== promoter && promoter) {
            this.onChange(date, promoter);
        }
    }

    render() {
        const { value } = this.props.field;

        return <DatePicker
            {...this.props}
            onChange={date => this.onChange(date)}
            showError={!!value}
            disabledDate={date => date.isAfter(moment())} />;
    }
}
